const divModalFilterUser = {
  cancel: 'CANCELAR',
  ok: 'APLICAR'
};

export default divModalFilterUser;
